import Swal from 'sweetalert2'

$(document).ready(function() {

    var favoriteLoading = false;
    $(document).on('click', '.add-to-favorite-btn', function() {
        var id = $(this).data('id');
        var type = $(this).data('type');
        var element = this;

        if (favoriteLoading) {
            console.log('loading...');
            return false;
        }

        
        favoriteLoading = true;

		var values = 'id=' + encodeURIComponent(id);
		values += '&type=' + encodeURIComponent(type);
        values += '&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        $.ajax({
            type: "POST",
            url: baseURL + "/account/favorites/save",
            data: values,
            success: function(response) {
                favoriteLoading = false;

                if (response.status == 1) {
                    $(element).addClass('active');
                    $(element).find('i').removeClass('far').addClass('fas');
                    $(element).removeClass('add-to-favorite-btn').addClass('remove-from-favorite-btn');

                    Swal.fire({
                        text: response.message
                    });
                    return;
                }

                Swal.fire({
                    text: response.message
                });
            },
            error: function() {
                favoriteLoading = false;
            }
        });
        
	});

    $(document).on('click', '.remove-from-favorite-btn', function() {
        var id = $(this).data('id');
        var type = $(this).data('type');
        var element = this;

        if (favoriteLoading) {
            console.log('loading...');
            return false;
        }

        Swal.fire({
            title: favorites_delete_title,
            text: favorites_delete_text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dd2121',
            cancelButtonColor: '#bbb',
            confirmButtonText: favorites_delete_btn_yes,
            cancelButtonText: favorites_delete_btn_no
        }).then((result) => {
            favoriteLoading = true;

            var values = 'id=' + encodeURIComponent(id);
            values += '&type=' + encodeURIComponent(type);
            values += '&_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            $.ajax({
                type: "POST",
                url: baseURL + "/account/favorites/delete",
                data: values,
                success: function(response) {
                    favoriteLoading = false;

                    if (response.status == 1) {
                        console.log($(element).data('source'));
                        if ($(element).data('source') == 'listing') {
                            $('#favorite-row-' + $(element).data('fid')).remove();
                        } else {
                            $(element).removeClass('active');
                            $(element).find('i').removeClass('fas').addClass('far');
                            $(element).removeClass('remove-from-favorite-btn').addClass('add-to-favorite-btn');
                        }

                        // Swal.fire({
                        //     text: response.message
                        // });
                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    favoriteLoading = false;
                }
            });
        });
        
	});

});